export const defaultState = () => ({
	siteSettings : {
		affiliateLink           : '',
		affiliateLinkPosition   : 'bottom',
		defaultIntegration      : '',
		globalAnalyticsID       : '',
		globalAnalyticsProfile  : '',
		globalInteractionCookie : false,
		globalSuccessCookie     : false,
		recaptchaSecretKey      : '',
		recaptchaSiteKey        : '',
	},
	miscSettings : {
		auto_updates       : 'all',
		hide_announcements : false,
		usage_tracking     : false,
	},
	providers         : [],
	integrations      : {},
	analyticsAccounts : [],
	analyticsProfiles : {},
})

export default defaultState()
